import {TPaths} from "app/lib/@types";
import i18next from 'app/lib/i18n/i18n';
import { useTranslation } from 'react-i18next';
import en from './en.json';
import ru from './ru.json';

const sharedTranslationNs = 'shared' as const;

i18next.addResourceBundle('en', sharedTranslationNs, en);
i18next.addResourceBundle('ru', sharedTranslationNs, ru);

declare module 'i18next' {
    interface i18nResources {
        [sharedTranslationNs]: typeof en;
    }
    interface CustomTypeOptions {
        // custom namespace type if you changed it
        // defaultNS: "ns1"
        // custom resources type
        resources: i18nResources;
    }
}

export type TSharedTranslationPaths = TPaths<typeof en> &
    TPaths<typeof ru>;

export type TSharedTranslationHook = (
    key: TSharedTranslationPaths,
    options?: Record<string, string | number>
) => string;

export function useSharedTranslations(): TSharedTranslationHook {
    const { t } = useTranslation(sharedTranslationNs);
    return t;
}
